export default {
  'DATE.JAN': 'January',
  'DATE.FEB': 'February',
  'DATE.MAR': 'March',
  'DATE.APR': 'April',
  'DATE.MAY': 'May',
  'DATE.JUN': 'June',
  'DATE.JUL': 'July',
  'DATE.AUG': 'August',
  'DATE.SEP': 'September',
  'DATE.OCT': 'October',
  'DATE.NOV': 'November',
  'DATE.DEC': 'December',

  'WEEK.SUN': 'Sunday',
  'WEEK.MON': 'Monday',
  'WEEK.TUE': 'Tuesday',
  'WEEK.WED': 'Wednesday',
  'WEEK.THU': 'Thursday',
  'WEEK.FRI': 'Friday',
  'WEEK.SAT': 'Saturday',

  'GENDER.MALE': 'Male',
  'GENDER.FEMALE': 'Female',
  'GENDER.OTHER': 'Other',

  'MARRIAGE.SINGLE': 'Single',
  'MARRIAGE.MARRIED': 'Married',
  'MARRIAGE.DIVORCE': 'Divorced',
  'MARRIAGE.WIDOWED': 'Widowed',
  'MARRIAGE.SEPARATION': 'Separated',

  'OCCUPATION.FREELANCER': 'Freelancer',
  'OCCUPATION.STUDENT': 'Student',
  'OCCUPATION.CONSTRUCTION': 'Construction',
  'OCCUPATION.FINANCE': 'Finance & Business',
  'OCCUPATION.AGRICULTURE': 'Agriculture & Fisheries',
  'OCCUPATION.EDUCATION': 'Education & Culture',
  'OCCUPATION.MEDIA': 'Media & Journalism',
  'OCCUPATION.RELIGION': 'Religious & Public Services',
  'OCCUPATION.HOSPITALITY': 'Hospitality & Catering',
  'OCCUPATION.TECHNOLOGY': 'Information Technology',
  'OCCUPATION.SPORTS': 'Sports',
  'OCCUPATION.HEALTHCARE': 'Healthcare',
  'OCCUPATION.TRANSPORTATION': 'Transportation',

  'INTEREST.OUTDOORS': 'Outdoor Activities',
  'INTEREST.SHOPPING': 'Shopping & Fashion',
  'INTEREST.DINING': 'Food & Dining',
  'INTEREST.TRAVEL': 'Travel',
  'INTEREST.ENTERTAINMENT': 'Music & Movies',
  'INTEREST.ARTS': 'Arts & Culture',
  'INTEREST.FITNESS': 'Fitness & Health',
  'INTEREST.TECHNOLOGY': 'Technology',
  'INTEREST.LEARNING': 'Education & Learning',
  'INTEREST.OTHERS': 'Others',

  'DIET.CARNIVORE': 'Meat-Lover',
  'DIET.ECO_VEGETARIAN': 'Eco-Vegetarian',
  'DIET.RELIGIOUS_VEGETARIAN': 'Religious Vegetarian',
  'DIET.FLEXIBLE': 'Flexible',

  'TAIWAN.CITY': '',

  'EDUCATION.JUNIOR': 'Junior High or Below',
  'EDUCATION.SENIOR': 'Senior High School',
  'EDUCATION.BACHELOR': 'Bachelor’s Degree',
  'EDUCATION.MASTER': 'Master’s Degree or Above',

  'MPS.SOURCE.8': 'Serial redemption',

  'MPS.EVENT.COLLECT': 'Points Collected',
  'MPS.EVENT.REDEEM': 'Points Redeemed',
  'MPS.EVENT.0': 'Below threshold - no points awarded',
  'MPS.EVENT.1': 'Spend threshold reached - points awarded',
  'MPS.EVENT.2': 'Birthday bonus',
  'MPS.EVENT.3': 'Member bonus',
  'MPS.EVENT.4': 'Flexible points awarding',
  'MPS.EVENT.5': 'Birthday bonus',
  'MPS.EVENT.6': 'Member bonus',
  'MPS.EVENT.7': 'Initial points awarded',
  'MPS.EVENT.8': 'Purchase discount points',
  'MPS.EVENT.9': 'Gift received',
  'MPS.EVENT.10': 'Flexible points deduction',
  'MPS.EVENT.11': 'Cash discount',
  'MPS.EVENT.12': 'Limited-time bonus',
  'MPS.EVENT.13': 'Member referral campaign',
  'MPS.EVENT.14': 'Member referral registration',
  'MPS.EVENT.15': 'Marketing campaign point reward',
  'MPS.EVENT.16': 'Online survey point reward',
  'MPS.EVENT.17': 'Serial redemption',
  'MPS.EVENT.20': 'Redemption - auto coupon conversion',
  'MPS.EVENT.21': 'Redemption - free coupon choice',
  'MPS.EVENT.30': 'Gift to friend',
  'MPS.EVENT.31': 'Points adjustment deduction',
  'MPS.EVENT.51': 'Points adjustment awarding',
  'MPS.EVENT.52': 'Admin compensation points',
  'MPS.EVENT.53': 'Transaction cancel - coupon recovery points return',
  'MPS.EVENT.54': 'Bonus points',
  'MPS.EVENT.55': 'Birthday gift',
  'MPS.EVENT.56': 'Welcome gift',
  'MPS.EVENT.57': 'Upgrade gift',
  'MPS.EVENT.91': 'Transaction cancel - spend threshold points',
  'MPS.EVENT.92': 'Transaction cancel - birthday bonus',
  'MPS.EVENT.93': 'Transaction cancel - member bonus',
  'MPS.EVENT.94': 'Deduct equivalent points for upgrade gift',
  'MPS.EVENT.95': 'Deduct equivalent points for birthday gift',
  'MPS.EVENT.96': 'Deduct equivalent points for coupon',
  'MPS.EVENT.97': 'Transaction cancel - limited-time bonus',
  'MPS.EVENT.99': 'Points expired',
  'MPS.EVENT.100': 'Cancel transaction - Marketing campaign',

  'COLLECT.EVENT.0': 'Not eligible for points',
  'COLLECT.EVENT.1': 'Spend threshold reached - points awarded',
  'COLLECT.EVENT.4': 'Flexible points awarding',
  'COLLECT.EVENT.10': 'Flexible points deduction',
  'COLLECT.EVENT.20': 'Auto coupon conversion',
  'COLLECT.EVENT.21': 'Free coupon choice',
  'COLLECT.EVENT.90': 'Points collection cancelled',
  'COLLECT.EVENT.91': 'Transaction cancelled - points deducted',
  'COLLECT.EVENT.92': 'Transaction cancelled - auto coupon conversion points returned',
  'COLLECT.EVENT.93': 'Points awarding cancelled',
  'COLLECT.EVENT.94': 'Points deduction cancelled',
} as Record<string, any>;
